import React from 'react';
import Private from '../../containers/private-route';
import Page from './component';

const Routes = [
    <Private exact
        key="determinants-route"
        path="/determinants"
        component={Page} />
];

export default Routes;